import React from "react";
import QueryString from "query-string";
import AppState from "./model/AppState";
import ObaTextField from "./components/ObaTextField";
import LogUtil from "./util/LogUtil";
import { FormControl, Snackbar } from "@material-ui/core";
import NavegadorUtil from "./util/NavegadorUtil";
import AlertaModel from "./model/AlertaModel";
import Carregando from "./components/Carregando";
import { ReactComponent as ImagemMenuBack } from "./assets/images/icons/menu-back.svg";
import Rodape from "./components/Rodape";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import ProxyEsqueciSenhaDAO from "./dataAccess/Proxy/ProxyEsqueciSenha";
import {Md5} from 'ts-md5/dist/md5';

interface IEsqueciProps extends RouteComponentProps {}

type EsqueciState = {
  email: string;
  carregando: boolean;
  concluido: boolean;
};

class Esqueci extends React.Component<IEsqueciProps, EsqueciState> {
  constructor(props: IEsqueciProps) {
    super(props);

    this.esqueci = this.esqueci.bind(this);

    this.state = {
      email: "",
      carregando: false,
      concluido: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Esqueci minha senha");

    const query: any = QueryString.parse(this.props.location.search);

    if (AppState.getUsuarioLogado() !== null) {
      if (query.returnUrl && query.returnUrl.length > 0) {
        NavegadorUtil.redirect(query.returnUrl, this.props.history);
      }
    }
  }

  esqueci(): void {
    const { email } = this.state;
    this.setState({ carregando: true });

    const hash = Md5.hashStr(JSON.stringify({ email }));

    ProxyEsqueciSenhaDAO.getInstance()
      .postEsqueciSenha(email, hash.toString())
      .then((r: any) => {
        this.setState({ carregando: false, concluido: true });
        NavegadorUtil.alerta(this, "E-mail enviado com sucesso");
      })
      .catch(async (ex) => {
        NavegadorUtil.alerta(
          this,
          `Erro ao recuperar senha do usuário [${ex.response.data.Message}].`
        );
        this.setState({ carregando: false, concluido: true });
      });
  }

  render(): any {
    const { email, carregando, concluido } = this.state;
    const fieldWidth: number = 300;
    const objStyle: any = {
      width: fieldWidth,
      margin: "0 auto",
      display: "block",
      marginTop: 20,
    };
    let alerta: any = AppState.getAlerta();

    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    return (
      <section className="login">
        <div
          className="header"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/img_login.png)`,
          }}
        >
          <div className="back" onClick={() => this.props.history.goBack()}>
            <ImagemMenuBack />
          </div>
        </div>
        <h1>Esqueci minha senha</h1>
        <FormControl variant="outlined" style={objStyle}>
          <ObaTextField
            onChange={(e) => this.setState({ email: e.target.value as string })}
            type="email"
            style={{ width: fieldWidth }}
            variant="outlined"
            label="E-mail"
            value={email}
          />
        </FormControl>
        <button onClick={this.esqueci}>Recuperar minha senha</button>
        <div className="subActions">
          <Link
            to={NavegadorUtil.getUrl("/login")}
            style={{ textAlign: "center", display: "block" }}
          >
            Ir para o login
          </Link>
        </div>
        <Carregando exibir={carregando} concluido={concluido} />
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Snackbar
          open={alerta.exibirModal}
          className="info"
          transitionDuration={1000}
          onClose={() => AppState.fecharAlerta(this)}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{alerta.mensagem}</span>}
        />
      </section>
    );
  }
}

export default withRouter(Esqueci);
